import {
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

const ObjectFilter = ({ allowClear, autoSelect, query = 'objectId' }) => {
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [searchParams, setSearchParams] = useSearchParams();

  const objects = useQuery({
    queryKey: '/dictionary/objects',
    queryFn: async function () {
      const response = await axiosPrivate.get('/dictionary/objects');
      return response.data.data;
    },
    enabled: !hasError,
    onSuccess: (data) => {
      if (data && data.length > 0) {
        if (autoSelect && !searchParams.get(query)) {
          searchParams.set(query, data?.[0]?.id);
          setSearchParams(searchParams);
        }
      }
    },
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  const handleChangeObject = (event) => {
    const {
      target: { value },
    } = event;
    searchParams.set(query, value);
    setSearchParams(searchParams);
  };

  const handleClearSelectBox = () => {
    searchParams.delete(query);
    setSearchParams(searchParams);
  };

  return (
    <FormControl fullWidth color='formColor'>
      <InputLabel id='objectId-label'>
        {t('common.fields.objectName')}
      </InputLabel>
      <Select
        labelId='objectId-label'
        id='objectId-select'
        label={t('common.fields.objectName')}
        onChange={handleChangeObject}
        value={searchParams.get(query) || ''}
        color='formColor'
        variant='outlined'
        role='presentation'
        MenuProps={{ id: 'objectId-select-menu' }}
        size='small'
        endAdornment={
          <InputAdornment position='end' className='custom-endAdornment'>
            {allowClear && searchParams.get(query) && (
              <IconButton
                onClick={() => handleClearSelectBox()}
                variant='onlyIcon'
                className='select-box-end-adornment-button'
              >
                <i className='bi bi-x end-adornment-close-button' />
              </IconButton>
            )}
          </InputAdornment>
        }
      >
        {objects.isLoading || objects.isFetching ? (
          <div className='circular-progress-box'>
            <CircularProgress size={25} />
          </div>
        ) : objects.data && objects.data.length > 0 ? (
          objects.data.map((item, index) => (
            <MenuItem value={item.id} key={index + 1} className='small-size'>
              {item.name}
            </MenuItem>
          ))
        ) : (
          <div>
            <span className='no-data-found-wrapper select-box'>
              <i className='bi bi-exclamation-octagon text-lg mr-1' /> Ma'lumot
              topilmadi!
            </span>
          </div>
        )}
      </Select>
    </FormControl>
  );
};
export default memo(ObjectFilter);
